export default __webpack_public_path__ + "static/media/structure.92488282.svg";